import { Component } from "preact";
import { isNullOrUndefined } from "util";
import { isNumber } from "../../../../utils/utility";
import { preventDefault } from "../../../../utils/common";
import { logEvent } from "../../../../utils/logger";

export default class MobileNumberInput extends Component {
  constructor(props) {
    super(props);
    this.state = { isError: false, errorName: "", inputValue: "" };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.isError !== this.props.isError || nextProps.errorName !== this.props.errorName) {
      this.setState({ isError: nextProps.isError, errorName: nextProps.errorName });
    }
  }

  validateNumberInput = event => {
    if (!isNumber(event)) {
      preventDefault(event);
    }
  };

  updateValue = event => {
    if (event && event.target) {
      this.setState(() => {
        return { inputValue: event.target.value.trim() };
      });
      this.props.updateFormValue(this.props.index, this.state.inputValue);
    }
  };

  clearErrors = () => {
    if (this.state.isError && !isNullOrUndefined(this.props.index)) {
      this.props.clearErrorData(this.props.index);
    }
    logEvent({ eventType: "clicked_form_field", eventValue: "mobile number form field", fieldName: this.props.name });
  };

  shouldComponentUpdate(nextProps) {
    if (
      nextProps.inputValue == this.props.inputValue &&
      nextProps.isError == this.props.isError &&
      nextProps.errorName == this.props.errorName
    ) {
      return false;
    }
  }

  pasteNumber = event => {
    setTimeout(() => {
      if (event && event.target) {
        const number = event.target.value;
        if (isNumber(number)) {
          this.setState(() => {
            return { inputValue: number.trim() };
          });
          this.props.updateFormValue(this.props.index, this.state.inputValue);
        } else {
          event.target.value = "";
        }
      }
    }, 0);
  };

  render({ name, constraints, placeholder, subText }) {
    const maxLength = constraints.maxLength ? constraints.maxLength : "";
    return (
      <div>
        <input
          name={name}
          type="text"
          value={this.state.inputValue}
          placeholder={placeholder}
          maxlength={maxLength}
          onKeyDown={this.validateNumberInput}
          onChange={this.updateValue}
          onFocus={this.clearErrors}
          onPaste={this.pasteNumber}
          autocomplete="off"
        />
        {subText && <p className="input-info">{subText}</p>}
        {this.state.isError && (
          <span className={`error ${subText ? "sub-txt-err" : ""}`} data-error-for={name}>
            {this.state.errorName}
          </span>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./form/components/inputs/mobilenumber/index.js